import { useSyncExternalStore } from 'react';

let connected = false;
const listeners = new Set<() => void>();

export function setRealtimeConnected(next: boolean): void {
  if (connected === next) {
    return;
  }
  connected = next;
  for (const listener of listeners) {
    listener();
  }
}

export function useRealtimeConnected(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => connected,
  );
}
